import { useNavigate } from 'react-router-dom';
import { useIndexedDBSyncV2 } from '../../../../database/dataLocal/indexedDBHooks';
import useQueries from '../../../../database/useQueries';
import { Box, Button, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { BtnCreatePurchase, GroupSizesColors } from './accessoriesStyles';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialogOnlyOk from '../../plagins/dialogs/ConfirmationDialogOnlyOk';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomDialog from '../../plagins/dialogs/customDialog';
// import PurchaseUpdatePer2 from "../../pagesUpdate/perrmision2/purchaseUpdate2";
import { useContext } from 'react';
import { GlobalContext } from '../../../../App';
import PurchaseTransfer from '../../pagesUpdate/perrmision2/purchaseTransfer';
import PurchaseUpdatePayments from '../../pagesUpdate/perrmision2/purchaseUpdatePayments';
import PurchaseUpdate from '../../pagesUpdate/purchaseUpdate';
import { DataContext } from '../../pagesMains/GravesManagers/Graves';
import { createFetchDataServer, getTableData } from '../../../../database/fetchData';

export const TabContentColumnsPurchase = ({ grave, purchase, burial, columns, onUpdate }) => {
  const { token, permission } = useContext(GlobalContext);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);
 
  const myPermissions = [1];
  const myPermissionsBookkeeping = [3];
  const myPermissionsPayments = [1, 3];
  const myPermissionsTransfer = [1];
  const myPermissionsCertificate = [1];

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr, removePurchase, addOrUpdateDataPurchase } = useQueries();

  const navigate = useNavigate();

  const myPurchase = getEntityByAttr(context?.contextPurchases, 'unicId', purchase?.unicId);

  const editItem = () => {
    navigate('/purchaseUpdate', { state: { grave: grave, value: purchase } });
  };

  // הסרת אחוזת קבר
  const deleteItem = () => {
    function isObjectEmpty(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    }

    let checkEntity = [];

    if (!isObjectEmpty(burial)) {
      checkEntity = [...checkEntity, true];
    }

    if (checkEntity?.length > 0) {
      alert('לא ניתן להסיר, קיים תיק מקושר');
    } else {
      setOpenAnswer(true);
      setTitle('מחיקת רכישה');
      setContent('האם את/ה בטוח/ה למחוק את הרכישה?');
    }
  };

  // המחיקת רכישה - בפועל
  const handleAnswer = (answer) => {
    setOpenAnswer(false);

    if (answer) {
      async function executeQueries() {
        try {
          // עדכון נתונים מקומיים
          let updatePurchase = getEntityByAttr(context?.contextPurchases, 'unicId', purchase?.unicId);
          let updateClient = getEntityByAttr(context?.contextCustomers, 'unicId', purchase?.clientId);
          let updateGrave = getEntityByAttr(context?.contextGraves, 'unicId', purchase?.graveId);

          let resAddOrUpdateDataPurchase = removePurchase({
            ...updatePurchase,
            updateGrave: { id: updateGrave?.id, unicId: updateGrave?.unicId, graveStatus: 1 },
            updateClient: { id: updateClient?.id, unicId: updateClient?.unicId, statusCustomer: 1, graveId: null }
          });

          // מחכה לכל השאילתות ביחד
          let results = await Promise.all([resAddOrUpdateDataPurchase]);

          // בודק אם כל התשובות הן 200
          if (results.every((res) => res === 200)) {
            // פעולות לאחר הצלחה
            navigate(-1);
          } else {
            // טיפול במקרה של כישלון
            console.error('אחת או יותר מהשאילתות נכשלה');
          }
        } catch (error) {
          console.error('שגיאה בביצוע השאילתות:', error);
        }
      }

      executeQueries();
    }
  };
  // אישור דיאלוג להפקת שטר קבר
  const handleAnswerCertificate = (answer) => {
    async function executeQueries() {
      try {
        // הוספת נתוני הקבר, הלקוח, והחתימות למבנה הנתונים שנשלח לשרת
        const requestData = {
          ...myPurchase,
          deedNum: myPurchase.serialPurchaseId,
          ifCertificate: 1
        };

        delete requestData?.cemeteryNameHe
        delete requestData?.blockNameHe
        delete requestData?.plotNameHe
        delete requestData?.lineNameHe
        delete requestData?.areaGraveNameHe
        delete requestData?.graveNameHe
        delete requestData?.cemeteryNameEn
        delete requestData?.blockNameEn
        delete requestData?.plotNameEn
        delete requestData?.lineNameEn
        delete requestData?.areaGraveNameEn
        delete requestData?.graveNameEn
        delete requestData?.cemeteryId
        delete requestData?.blockId
        delete requestData?.plotId
        delete requestData?.lineId
        delete requestData?.areaGraveId
        delete requestData?.graveStatus
        delete requestData?.graveComments
        delete requestData?.clientFullNameHe
        delete requestData?.contactFullNameHe
        

        // שליחת הנתונים לשרת בפנייה אחת
        let res = await addOrUpdateDataPurchase(requestData);
        setOpenCertificate(false);
        // בדיקת התוצאה
        if (res === 200) {
          // פעולות לאחר הצלחה

        // אם העברת את `onUpdate`, עדכן את האב עם הנתונים החדשים
        if (onUpdate) {
          onUpdate(
            {
              // ...myPurchase,
              deedNum: myPurchase.serialPurchaseId,
              ifCertificate: 1
            }
          ); // שליחת המידע המעודכן לאב
        }
          
          console.log('הונפק');
        } else {
          // טיפול במקרה של כישלון
          console.error('השאילתה נכשלה');
        }
      } catch (error) {
        console.error('שגיאה בביצוע השאילתות:', error);
      }
    }

    if (answer) {
      setOpenCertificate(false);
      executeQueries();
    } else {
      // setOpenAnswer(false)
      setOpenCertificate(false);
    }
  };

  const [openPurchase, setOpenPurchase] = useState(false);
  const [openBookkeeping, setOpenBookkeeping] = useState(false);
  const [openTransfer, setOpenTransfer] = useState(false);
  const [openCertificate, setOpenCertificate] = useState(false);

  const [openAnswer, setOpenAnswer] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  // יצירת ref עבור הרכיב PurchaseUpdatePayments
  const purchaseUpdatePaymentsRef = useRef(null);

  const handleAnswerPayments = async (answer) => {

    if (purchaseUpdatePaymentsRef.current) {
      // הפעלת הפונקציה מתוך הרכיב הפנימי עם העברת ה-answer
      setOpenBookkeeping(await purchaseUpdatePaymentsRef.current.handleAnswerOk(answer));
    }
  };

  useEffect(() => {
    fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'graves', 'customers', 'purchasesOld',], token);
  }, []);

  return (
    <>
    {columns?.length > 0 ?
          <Grid
          container
          direction="column"
          style={{
            height: '100%',
            position: 'relative' // כדי לאפשר מיקום אבסולוטי של האייקונים
          }}>
            {JSON.stringify(myPurchase?.ifCertificate)}
            {JSON.stringify(myPurchase?.deedNum)}
          {/* גריד עליון */}
          <Grid
            item
            style={{
              flex: 1
            }}>
            <Grid container spacing={2}>
              {columns?.map((column, index) => (
                <Grid item xs={4} key={index}>
                  <Box sx={{ textAlign: 'left' }}>
                    <Typography color="textSecondary">
                      <span style={{ fontWeight: 'bold' }}>{column?.title}</span>
                      <span>{`: `}</span>
                      <span>{column?.value}</span>
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
  
          {/* אייקונים של עריכה ומחיקה בפינה העליונה השמאלית */}
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              display: 'flex',
              gap: 1
            }}>
            {(permission === 0 || myPermissions.includes(permission)) && (
              <>
                <Tooltip title="עריכה">
                  <IconButton onClick={editItem} sx={{ color: 'lightblue' }}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="מחיקה">
                  <IconButton onClick={deleteItem} sx={{ color: 'lightcoral' }}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>
  
          {/* גריד תחתון */}
          <Grid item>
            <GroupSizesColors
              buttons={[
                <Button key="one" onClick={() => setOpenPurchase(true)} disabled={myPurchase?.ifCertificate ? myPurchase?.ifCertificate : permission === 0 ? false : !(myPermissionsBookkeeping.includes(permission) && myPurchase?.buyerStatus !== 2)}>
                  אישור הנה״ח
                </Button>,
  
                <Button key="two" onClick={() => setOpenBookkeeping(true)} disabled={permission === 0 ? false : !myPermissionsPayments.includes(permission)}>
                  מודול תשלומים
                </Button>,
                <Button key="three" onClick={() => setOpenCertificate(true)} disabled={myPurchase?.ifCertificate ? myPurchase?.ifCertificate : permission === 0 ? false : !(myPermissionsCertificate.includes(permission) && myPurchase?.BookkeepingApproval === 2)}>
                  הפקת שטר קבורה
                </Button>,
                <Button key="four" onClick={() => setOpenTransfer(true)} disabled={permission === 0 ? false : !(myPermissionsTransfer.includes(permission) && myPurchase?.BookkeepingApproval === 2)}>
                  העברת בעלות
                </Button>
              ]}
            />
          </Grid>
  
          {/* דיאלוג אישור הנהח */}
          <CustomDialog open={openPurchase} handleClose={() => setOpenPurchase(false)} title={'רכישת קבר'}>
            <PurchaseUpdate plotId={1} propValue={purchase} handleClose={() => setOpenPurchase(false)} />
          </CustomDialog>
  
          {/* דיאלוג תשלומים */}
          <CustomDialog
            open={openBookkeeping}
            handleClose={() => setOpenBookkeeping(false)}
            title={'ניהול תשלומים'}
            onOk={true}
            onCancel={true}
            no="ביטול"
            yes="אישור"
            onAnswer={handleAnswerPayments} // תוודא שהפונקציה מופעלת כאשר נלחץ אישור
            width={{
              minWidth: '400px',
              maxWidth: '80%'
            }}>
            <PurchaseUpdatePayments
              ref={purchaseUpdatePaymentsRef} // העברת ה-ref
              plotId={1}
              value={myPurchase}
              handleClose={() => setOpenBookkeeping(false)}
              // handleAnswerOk={handleAnswerOk} // העברת הפונקציה כ- prop
            />
          </CustomDialog>
  
          {/* דיאלוג להנפקת שטר */}
          <CustomDialog open={openCertificate} handleClose={() => setOpenCertificate(false)} title={'הפקת שטר'} onOk={true} onCancel={true} no="ביטול" yes="אישור" onAnswer={handleAnswerCertificate}>
            <Typography>לאחר הפקת השטר, ניתן להדפיסו תחת לשונית מסמכים</Typography>
          </CustomDialog>
  
          {/* דיאלוג להעברת בעלות */}
          <CustomDialog open={openTransfer} handleClose={() => setOpenTransfer(false)} title={'העברת בעלות'}>
          {/* grave: grave, value: purchase */}
            <PurchaseTransfer  plotId={1} propPurchase={purchase} propGrave={grave} handleClose={() => setOpenTransfer(false)} />
          </CustomDialog>
  
          {/* דיאלוג מחיקה */}
          <ConfirmationDialogOnlyOk open={openAnswer} title={title} content={content} onAnswer={handleAnswer} />
        </Grid> :
        <BtnCreatePurchase graveId={grave} content={burial} />
    }
    </>
  )

  // useEffect(() => {
  //   console.log('step3:',columns);
  // }, [columns]);

  // if (columns?.length > 0) {
  //   return (
  //     <Grid
  //       container
  //       direction="column"
  //       style={{
  //         height: '100%',
  //         position: 'relative' // כדי לאפשר מיקום אבסולוטי של האייקונים
  //       }}>
  //         {JSON.stringify(myPurchase?.ifCertificate)}
  //         {JSON.stringify(myPurchase?.deedNum)}
  //       {/* גריד עליון */}
  //       <Grid
  //         item
  //         style={{
  //           flex: 1
  //         }}>
  //         <Grid container spacing={2}>
  //           {columns?.map((column, index) => (
  //             <Grid item xs={4} key={index}>
  //               <Box sx={{ textAlign: 'left' }}>
  //                 <Typography color="textSecondary">
  //                   <span style={{ fontWeight: 'bold' }}>{column?.title}</span>
  //                   <span>{`: `}</span>
  //                   <span>{column?.value}</span>
  //                 </Typography>
  //               </Box>
  //             </Grid>
  //           ))}
  //         </Grid>
  //       </Grid>

  //       {/* אייקונים של עריכה ומחיקה בפינה העליונה השמאלית */}
  //       <Box
  //         sx={{
  //           position: 'absolute',
  //           bottom: 8,
  //           right: 8,
  //           display: 'flex',
  //           gap: 1
  //         }}>
  //         {(permission === 0 || myPermissions.includes(permission)) && (
  //           <>
  //             <Tooltip title="עריכה">
  //               <IconButton onClick={editItem} sx={{ color: 'lightblue' }}>
  //                 <EditIcon />
  //               </IconButton>
  //             </Tooltip>
  //             <Tooltip title="מחיקה">
  //               <IconButton onClick={deleteItem} sx={{ color: 'lightcoral' }}>
  //                 <DeleteIcon />
  //               </IconButton>
  //             </Tooltip>
  //           </>
  //         )}
  //       </Box>

  //       {/* גריד תחתון */}
  //       <Grid item>
  //         <GroupSizesColors
  //           buttons={[
  //             <Button key="one" onClick={() => setOpenPurchase(true)} disabled={myPurchase?.ifCertificate ? myPurchase?.ifCertificate : permission === 0 ? false : !(myPermissionsBookkeeping.includes(permission) && myPurchase?.buyerStatus !== 2)}>
  //               אישור הנה״ח
  //             </Button>,

  //             <Button key="two" onClick={() => setOpenBookkeeping(true)} disabled={permission === 0 ? false : !myPermissionsPayments.includes(permission)}>
  //               מודול תשלומים
  //             </Button>,
  //             <Button key="three" onClick={() => setOpenCertificate(true)} disabled={myPurchase?.ifCertificate ? myPurchase?.ifCertificate : permission === 0 ? false : !(myPermissionsCertificate.includes(permission) && myPurchase?.BookkeepingApproval === 2)}>
  //               הפקת שטר קבורה
  //             </Button>,
  //             <Button key="four" onClick={() => setOpenTransfer(true)} disabled={permission === 0 ? false : !(myPermissionsTransfer.includes(permission) && myPurchase?.BookkeepingApproval === 2)}>
  //               העברת בעלות
  //             </Button>
  //           ]}
  //         />
  //       </Grid>

  //       {/* דיאלוג אישור הנהח */}
  //       <CustomDialog open={openPurchase} handleClose={() => setOpenPurchase(false)} title={'רכישת קבר'}>
  //         <PurchaseUpdate plotId={1} propValue={purchase} handleClose={() => setOpenPurchase(false)} />
  //       </CustomDialog>

  //       {/* דיאלוג תשלומים */}
  //       <CustomDialog
  //         open={openBookkeeping}
  //         handleClose={() => setOpenBookkeeping(false)}
  //         title={'ניהול תשלומים'}
  //         onOk={true}
  //         onCancel={true}
  //         no="ביטול"
  //         yes="אישור"
  //         onAnswer={handleAnswerPayments} // תוודא שהפונקציה מופעלת כאשר נלחץ אישור
  //         width={{
  //           minWidth: '400px',
  //           maxWidth: '80%'
  //         }}>
  //         <PurchaseUpdatePayments
  //           ref={purchaseUpdatePaymentsRef} // העברת ה-ref
  //           plotId={1}
  //           value={myPurchase}
  //           handleClose={() => setOpenBookkeeping(false)}
  //           // handleAnswerOk={handleAnswerOk} // העברת הפונקציה כ- prop
  //         />
  //       </CustomDialog>

  //       {/* דיאלוג להנפקת שטר */}
  //       <CustomDialog open={openCertificate} handleClose={() => setOpenCertificate(false)} title={'הפקת שטר'} onOk={true} onCancel={true} no="ביטול" yes="אישור" onAnswer={handleAnswerCertificate}>
  //         <Typography>לאחר הפקת השטר, ניתן להדפיסו תחת לשונית מסמכים</Typography>
  //       </CustomDialog>

  //       {/* דיאלוג להעברת בעלות */}
  //       <CustomDialog open={openTransfer} handleClose={() => setOpenTransfer(false)} title={'העברת בעלות'}>
  //       {/* grave: grave, value: purchase */}
  //         <PurchaseTransfer  plotId={1} propPurchase={purchase} propGrave={grave} handleClose={() => setOpenTransfer(false)} />
  //       </CustomDialog>

  //       {/* דיאלוג מחיקה */}
  //       <ConfirmationDialogOnlyOk open={openAnswer} title={title} content={content} onAnswer={handleAnswer} />
  //     </Grid>
  //   );
  // } else {
  //   return <BtnCreatePurchase graveId={grave} content={burial} />;
  // }
};
